export default "__VITE_ASSET__FKmRAGJX__"